import { IconButton, Box } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import { componentsProps } from './Type'
import useStyle from './Styles'
import { useSlots, useUtils } from '../Hooks'
import Day from './Day'
import LoadingsSlot from './Loading'

const Weeks: React.FC<componentsProps> = ({
  handleClickOnSlot,
  slots,
  loading,
}): React.ReactElement => {
  const [indexPage, setIndexPage] = useState(0)
  const [transitionLoading, setTransitionLoading] = useState(true)
  const { slotsByDay, daysForward } = useSlots(slots)
  const { numberDays, screenXs } = useUtils()
  const classes = useStyle({ numberDays })

  const onIncrementPage = () => {
    setIndexPage(indexPage + 1)
  }

  const onDecrementPage = () => {
    setIndexPage(indexPage - 1)
  }

  const renderDays = () => {
    const days = []

    for (let i = indexPage * numberDays; i < (indexPage + 1) * numberDays; i++) {
      days.push(<Day index={i} handleClickOnSlot={handleClickOnSlot} slotsByDay={slotsByDay} />)
    }

    return days.filter((el) => el !== null)
  }

  useEffect(() => {
    setTimeout(() => {
      setTransitionLoading(false)
    }, 300)
  }, [])

  if (loading || transitionLoading) {
    return <LoadingsSlot />
  }

  const days = renderDays()

  return (
    <div className={classes.picker}>
      <IconButton
        onClick={onDecrementPage}
        className={classes.decrementButton}
        color="primary"
        disabled={indexPage === 0}
      >
        <ChevronLeft fontSize="large" />
      </IconButton>

      <Box className={classes.days} data-cy="visitorSlot__container">
        {renderDays()}
      </Box>

      <IconButton
        onClick={onIncrementPage}
        color="primary"
        disabled={
          (indexPage + 1) * numberDays >= daysForward ||
          (screenXs && days.length < indexPage * numberDays)
        }
        data-cy="visitorSlot__rightArrow"
        className={classes.incrementButton}
      >
        <ChevronRight fontSize="large" />
      </IconButton>

      <div className={classes.picker__divider} />
    </div>
  )
}

export default Weeks
